import { FC } from "react";
import { Modal, TableProps } from "@monolith-forensics/monolith-ui";

import { ImportDefinition } from "./DataImport.types";
import { DataImport } from "./DataImport";

export interface DataImportModalProps {
  open: boolean;
  onClose: () => void;
  definition: ImportDefinition;
  onComplete?: () => void;
  previewTableProps?: TableProps;
}

export const DataImportModal: FC<DataImportModalProps> = ({
  open,
  onClose,
  definition,
  onComplete,
  previewTableProps,
}) => (
  <Modal
    open={open}
    onClose={onClose}
    style={{ width: "95vw", height: "90vh", maxWidth: "95vw" }}
  >
    <Modal.Title>{definition.title}</Modal.Title>
    <DataImport
      definition={definition}
      onClose={onClose}
      onComplete={onComplete}
      previewTableProps={previewTableProps}
    />
  </Modal>
);
